import {useEffect, useState} from "react"
import LibraryMembershipResponse from "./membership/LibraryMembershipResponse"
import {BooksitoutServer} from "../../config/BooksitoutServer"

const useLibraryMembershipList = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [libraryMemberships, setLibraryMemberships] = useState<LibraryMembershipResponse[]>([])

    useEffect(() => {
        BooksitoutServer
            .get(`/v1/library/membership`)
            .then((res) => setLibraryMemberships(res.data))
            .finally(() => setIsLoading(false))
    }, [])

    return [isLoading, libraryMemberships] as const
}

export default useLibraryMembershipList